import { Component, OnInit } from '@angular/core';
import { ResourceType } from '../../../dto/resource-type.enum';
import { AddResourceData } from './add-resource-data';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout/flex';
import {
  MatFormField,
  MatSuffix,
  MatLabel
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mfa-add-resource',
  templateUrl: './add-resource.component.html',
  styleUrls: ['./add-resource.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FlexModule,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatTooltip,
    MatIcon,
    MatSuffix,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class AddResourceComponent implements OnInit {
  constructor() {}
  data = new AddResourceData('', ResourceType.WindowsLogin);
  resourceType = ResourceType;
  ngOnInit() {}
}
